import * as React from 'react';
import * as main from "../../styles/main.module.scss";
import * as edu from "./style.module.scss";

export const EducationEng = () => {
  return (
    <section className={edu.education} id="structure">
      <div className="container">
        <h2 className={`${main.titleH2} ${edu.education__title}`}>
          Как проходит обучение в&nbsp;мини-группах?
        </h2>
        <div className={edu.education__blocks}>
          <div className={edu.education__block}>
            <img src="https://fs.advance.ru/landing-pages/inostrannye_yazyki/kuratorskoe_soprovozhdenie__common/icon-how-01.png" alt=""/>
            <div className={edu.education__blockText}>
              Куратор выдает задание и&nbsp;устанавливает дедлайн
            </div>
          </div>
          <div className={edu.education__block}>
            <img src="https://fs.advance.ru/landing-pages/inostrannye_yazyki/kuratorskoe_soprovozhdenie__common/kurs-icon-02.png" alt=""/>
            <div className={edu.education__blockText}>
              Контролирует прогресс, помогает в&nbsp;обучении, отвечает на&nbsp;вопросы
            </div>
          </div>
          <div className={edu.education__block}>
            <img src="https://fs.advance.ru/landing-pages/inostrannye_yazyki/kuratorskoe_soprovozhdenie__common/icon-how-03.png" alt=""/>
            <div className={edu.education__blockText}>
              Даёт задания на&nbsp;отработку навыков запоминания
            </div>
          </div>
          <div className={edu.education__block}>
            <img src="https://fs.advance.ru/landing-pages/inostrannye_yazyki/kuratorskoe_soprovozhdenie__common/icon-how-04.png" alt=""/>
            <div className={edu.education__blockText}>
              Проверяет, исправляет ошибки и&nbsp;даёт рекомендации
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
